/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
const e = () => {
  let r = "", t, o;
  for (t = 0; t < 32; t++)
    o = Math.random() * 16 | 0, (t === 8 || t === 12 || t === 16 || t === 20) && (r += "-"), r += (t === 12 ? 4 : t === 16 ? o & 3 | 8 : o).toString(16);
  return r;
};
export {
  e as guid
};
